<template>
  <el-form-item :label="label" :label-width="labelWidth">
    <el-select
      v-model="selectedId"
      placeholder="请选择功能"
      style="width: 100%;"
      filterable
      clearable
      :disabled="disabled"
    >
      <el-option v-for="item in menus" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: "MenuSelector",
  props: {
    label: String,
    labelWidth: String,
    menuid:Number
  },
  data() {
    return {
      selectedId: null,
      menus: [],
      disabled: false
    };
  },
  methods: {
    query() {
      var self = this;
      this.$axios.get("system/permission/query").then(function(response) {
        if (response.data.errorCode == "00000") {
          self.menus = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    }
  },
  created: function() {
    console.log("cust selector created");
    this.selectedId = this.menuid;
    this.query();
  }
};
</script>